import { BillSummaryStateTypes, BillSummaryActionTypes } from "./BillSummary.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: BillSummaryStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const BillSummaryReducer = (
  state: BillSummaryStateTypes = INITIAL_STATE,
  action: any
): BillSummaryStateTypes => {
  switch (action.type) {
    case BillSummaryActionTypes.FETCH_ALL_BILL_SUMMARY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case BillSummaryActionTypes.FETCH_ALL_BILL_SUMMARY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BillSummaryActionTypes.FETCH_ALL_BILL_SUMMARY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BillSummaryActionTypes.FETCH_ALL_BILL_SUMMARY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case BillSummaryActionTypes.FETCH_ONE_BILL_SUMMARY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case BillSummaryActionTypes.FETCH_ONE_BILL_SUMMARY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case BillSummaryActionTypes.FETCH_ONE_BILL_SUMMARY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case BillSummaryActionTypes.FETCH_ONE_BILL_SUMMARY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default BillSummaryReducer;
